export default __webpack_public_path__ + "static/media/slide12.4d5e8a84.webp";